import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles/output.css";
import 'antd/dist/antd.css';

ReactDOM.render(<App />, document.getElementById("root"));
